import React, { useEffect, useState } from "react";
import { Pagination, Spinner } from "../../../../components/common";
import { ActivityLogsFilter } from "./ActivityLogsFilter";
import { useDispatch } from "react-redux";
import { activityLogsActions } from "../../../../store/activityLogs/activityLogsActions";
import { ActivityLogsList } from "./ActivityLogsList";
import { endpoints } from "../../../../config/apiConfig";
import moment from "moment";

const loadEmailsSearchable = async (fieldValue) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ input: fieldValue }),
    };
    const dataResponse = await fetch(
        `${endpoints.companies.getEndUserCompanyAutoComplete}`,
        requestOptions
    );
    return dataResponse.json();
};

const ActivityLogsDataView = ({ activeTabId, setActiveTabId }) => {
    const [isLoading, setLoading] = useState(false);
    const [logsList, setLogsList] = useState([]);

    const [controllerList, setControllerList] = useState([]);
    const [actionsList, setActionsList] = useState([]);

    const [isFilterApplied, setIsFilterApplied] = useState(false);
    const dispatch = useDispatch();
    const [paginationResponse, setPaginationResponse] = useState({
        currentCount: 0,
        totalRecords: 0,
    });
    const [filterModel, setFilters] = useState({
        search: "",
        start: null,
        end: null,
        userId: "",
        platform: "",
        controller: "",
        action: "",
    });
    const [selectedUser, setSelectedUser] = useState("");
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrderBy] = useState({
        orderByKey: "RequestTime",
        orderVal: 0,
    });
    const [usersList, setUsersList] = useState([]);

    const getControllersList = () => {
        dispatch(activityLogsActions.onGetUserActivityControllerList()).then(response => {
            if (response.success) {
                setControllerList(response.data);
            } else {
                setControllerList([]);
            }
        })
            .catch(error => {
                setControllerList([]);
            });
    };

    const getActionsList = () => {
        dispatch(activityLogsActions.onGetUserActivityActionList()).then(response => {
            if (response.success) {
                setActionsList(response.data);
            } else {
                setActionsList([]);
            }
        })
            .catch(error => {
                setActionsList([]);
            });
    };

    useEffect(() => {
        loadEmailsSearchable("").then(data => {
            if (data.success) {
                setUsersList(data.data);
            } else {
                setUsersList([]);
            }
        });
        getControllersList();
        getActionsList();
    }, []);

    const getLogsData = () => {
        setLoading(true);
        const payload = {
            ...filterModel,
            pagination: {
                pageSize: rowsPerPage,
                pageNo: page,
                orderByKey: order.orderByKey,
                orderByVal: order.orderVal,
            }
        };
        dispatch(activityLogsActions.onGetUserActivities(payload)).then(response => {
            if (response && response.data?.length) {
                // setLogsList(response);
                setLogsList(response.data);
                setPaginationResponse(response.pagination);
            } else {
                setLogsList([]);
                setPaginationResponse({
                    currentCount: 0,
                    totalRecords: 0,
                });
            }
            setLoading(false);
        })
            .catch(error => {
                setLogsList([]);
                setLoading(false);
                setPaginationResponse({
                    currentCount: 0,
                    totalRecords: 0,
                });
            });
    };

    useEffect(() => {
        if (filterModel.userId) {
            getLogsData();
        }
    }, [
        order.orderByKey,
        order.orderVal,
        page,
        rowsPerPage
    ]);

    const onApplyFilters = (filter) => {
        if (page === 1 && filter.userId) {
            setLoading(true);
            const payload = {
                ...filter,
                pagination: {
                    pageSize: rowsPerPage,
                    pageNo: page,
                    orderByKey: order.orderByKey,
                    orderByVal: order.orderVal,
                }
            };
            dispatch(activityLogsActions.onGetUserActivities(payload)).then(response => {
                if (response && response.data?.length) {
                    setLogsList(response.data);
                    setPaginationResponse(response.pagination);
                } else {
                    setLogsList([]);
                    setPaginationResponse({
                        currentCount: 0,
                        totalRecords: 0,
                    });
                }
                setLoading(false);
            })
                .catch(error => {
                    setLogsList([]);
                    setLoading(false);
                    setPaginationResponse({
                        currentCount: 0,
                        totalRecords: 0,
                    });
                });
        } else if (!filter.usedId) {
            setLogsList([]);
            setPaginationResponse({
                currentCount: 0,
                totalRecords: 0,
            });
        }
    }

    useEffect(() => {
        setPage(1);
    }, [
        filterModel.userId,
        filterModel.start,
        filterModel.end,
        filterModel.platform,
        filterModel.search,
        filterModel.controller,
        filterModel.action,
    ]);

    const headers = [
        { label: 'Index', key: 'id' },
        { label: 'Log ID', key: 'logId' },
        { label: 'User ID', key: 'userId' },
        { label: 'User Name', key: 'userName' },
        { label: 'IP Address', key: 'ipAddress' },
        { label: 'Platform', key: 'platform' },
        { label: 'Message', key: 'message' },
        { label: 'Controller Name', key: 'controllerName' },
        { label: 'Action Method Name', key: 'actionMethodName' },
        { label: 'Request Path', key: 'requestPath' },
        { label: 'Payload', key: 'payload' },
        { label: 'Request', key: 'request' },
        { label: 'Request Time', key: 'requestTime' },
    ];

    const downloadCSV = (jsonArray) => {
        if (!Array.isArray(jsonArray) || jsonArray.length === 0) {
            console.error('Invalid or empty JSON array');
            return;
        }

        const csvRows = [headers.map(x => x.label).join(',')];

        for (const item of jsonArray) {
            const values = headers.map(header => {
                const escapedValue = String(item[header.key] ?? 'N/A').replace(/"/g, '""');
                return `"${escapedValue}"`;
            });
            csvRows.push(values.join(','));
        }

        const csvString = csvRows.join('\n');

        const bom = '\uFEFF';
        const csvWithBom = bom + csvString;

        const blob = new Blob([csvWithBom], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        let fileName = `${selectedUser}-${moment(filterModel.start).format('DD/MM/YYYY')}`;
        if (filterModel.end) {
            fileName = `${fileName}-${moment(filterModel.end).format('DD/MM/YYYY')}`
        }
        fileName = `${fileName}-${new Date().getMilliseconds()}.csv`;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    const handleExport = () => {
        setLoading(true);
        const payload = {
            ...filterModel,
            isExport: true,
            pagination: {
                pageSize: rowsPerPage,
                pageNo: page,
                orderByKey: order.orderByKey,
                orderByVal: order.orderVal,
            }
        };
        dispatch(activityLogsActions.onGetUserActivities(payload)).then(response => {
            if (response && response.length) {
                const dataForExport = response.map((item, index) => ({
                    ...item,
                    id: index + 1,
                    logId: item.id,
                    requestTime: moment(item.requestTime).format("MMMM DD, YYYY"),
                }));
                downloadCSV(dataForExport);
                setLoading(false);
            }
            setLoading(false);
        })
            .catch(error => {
                setLoading(false);
            });
    }

    return (
        <div className="gridBody contentBody businessCustomerGrid tableInnerWrapper">
            {isLoading ? <Spinner /> : null}
            <ActivityLogsFilter
                IsFilterApplied={isFilterApplied}
                usersList={usersList}
                PaginationResponse={paginationResponse}
                AppliedFilters={filterModel}
                onApplyFilters={(filters, isFilterApplied) => {
                    setFilters(filters);
                    setIsFilterApplied(!isFilterApplied);
                    onApplyFilters(filters);
                }}
                controllers={controllerList}
                allActions={actionsList}
                ActiveTabId={activeTabId}
                setActiveTabId={setActiveTabId}
                setSelectedUser={setSelectedUser}
            />
            <h2 className='gridInnerHeading'>
                {selectedUser.length > 0 ? `${selectedUser}'s activity logs` : "Please Select A User And Date(s)"}
                <span className='gridTopPagination'>
                    <Pagination
                        recordCount={paginationResponse?.totalRecords}
                        page={page - 1}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        rowsPerPageOptions={[]}
                        backIconButtonProps={{ style: { display: "none" } }}
                        nextIconButtonProps={{ style: { display: "none" } }}
                    />
                </span>
            </h2>
            <ActivityLogsList
                logsData={logsList}
                order={order}
                onOrderBy={setOrderBy}
                handleExport={handleExport}
                page={page}
                selectedUserId={filterModel.userId}
            />
            <Pagination
                recordCount={paginationResponse.totalRecords}
                page={page - 1}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
            />
        </div>
    );
};

export { ActivityLogsDataView };
